import React from 'react'
import { flushSync } from 'react-dom'
import PrimaryButton from '../Button/PrimaryButton'
import { Link } from 'react-router-dom'

const RegistrasiModal = ({ open, onClose }) => {
  // Modal harus sudah tertutup sebelum halaman berganti. Kalau elemen
  // `.modal-open` ikut terbuang dari DOM, Firefox tidak melepas kunci scroll
  // daisyUI (`:root:has(.modal-open) { overflow: hidden }`), sehingga halaman
  // registrasi baru bisa di-scroll setelah di-reload.
  const closeBeforeLeaving = () => flushSync(onClose)

  return (
    <div className={`modal ${open && 'modal-open'}`}>
      <div className="modal-box relative">
        <button
          className="btn btn-ghost btn-circle absolute right-2 top-2"
          onClick={onClose}
        >
          ✕
        </button>
        <h1 className="text-xl font-semibold">Registrasi KTA</h1>
        <p className="my-4">
          Daftarlah untuk mendapatkan KTA baru atau perpanjang masa berlaku KTA
          Anda sekarang.
        </p>
        <div className="flex justify-end items-center gap-2">
          <Link to="/new-registration" onClick={closeBeforeLeaving}>
            <PrimaryButton>Daftar KTA Baru</PrimaryButton>
          </Link>
          <Link to="/renew-registration" onClick={closeBeforeLeaving}>
            <PrimaryButton>Perpanjang KTA</PrimaryButton>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default RegistrasiModal
